// PDP cross-sell fallback via Shopify Recommendations API
(() => {
  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `${amount} €`;
  };

  const getSizeOptionIndex = (product) => {
    const options = product.options || [];
    return options.findIndex((option) => {
      const name = typeof option === 'string' ? option : option.name;
      if (!name) return false;
      const down = name.toLowerCase();
      return down.includes('size') || down.includes('talla') || down.includes('talle');
    });
  };

  const renderItem = (product) => {
    const variant = product.variants && product.variants[0];
    const img = product.featured_image || (product.images && product.images[0]);
    const escapeAttr = (value) => String(value || '').replace(/"/g, '&quot;');
    const variantsJson = JSON.stringify(product.variants || []).replace(/</g, '\\u003c');
    const imgSrc = img ? (typeof img === 'string' ? img : img.src) : '';
    const imgTag = imgSrc
      ? `<img src="${imgSrc.replace(/\.(jpg|jpeg|png|webp)/i, '_160x.$1')}" alt="${escapeAttr(product.title)}" loading="lazy">`
      : '';
    const price = formatMoney(product.price || (variant && variant.price) || 0);
    const sizeOptionIndex = getSizeOptionIndex(product);
    const hasDefaultVariant = product.variants && product.variants.length === 1 && variant && variant.available;
    const hasSizeSelector = sizeOptionIndex > -1 && product.variants && product.variants.length > 1;

    const imageHtml = `<a href="${product.url}" class="pdp__crosssell-image">${imgTag}</a>`;

    const sizeGridHtml = hasSizeSelector
      ? `<div class="pdp__crosssell-size-grid" role="radiogroup" aria-label="Selecciona talla para ${escapeAttr(product.title)}">
           ${Array.from(product.variants.reduce((sizes, candidate) => {
             const sizeValue = candidate.options && candidate.options[sizeOptionIndex] ? candidate.options[sizeOptionIndex] : candidate.title;
             const previous = sizes.get(sizeValue);
             if (!previous || (!previous.available && candidate.available)) sizes.set(sizeValue, candidate);
             return sizes;
           }, new Map()).values()).map((candidate) => {
             const sizeValue = candidate.options && candidate.options[sizeOptionIndex] ? candidate.options[sizeOptionIndex] : candidate.title;
             const unavailable = candidate.available ? '' : ' is-unavailable';
             const disabled = candidate.available ? '' : 'disabled';
             return `<label class="pdp__size pdp__crosssell-size${unavailable}">
               <input type="radio" name="crosssell-size-${product.id}" value="${escapeAttr(sizeValue)}" data-crosssell-option-input data-option-index="${sizeOptionIndex}" data-variant-id="${candidate.id}" ${disabled}>
               <span>${sizeValue}</span>
             </label>`;
           }).join('')}
         </div>`
      : '';

    const infoHtml = `
      <div class="pdp__crosssell-info">
        <a href="${product.url}" class="pdp__crosssell-name">${product.title}</a>
        <span class="pdp__crosssell-price">${price}</span>
        ${sizeGridHtml}
      </div>`;

    if (hasSizeSelector) {
      return `
        <div class="pdp__crosssell-item has-size-selector">
          <div class="pdp__crosssell-form" data-crosssell-auto-add>
            ${imageHtml}
            ${infoHtml}
            <input type="hidden" value="${variant.id}" data-crosssell-variant-id>
            <script type="application/json" data-crosssell-variants>${variantsJson}</script>
          </div>
        </div>`;
    }
    if (hasDefaultVariant) {
      return `
        <div class="pdp__crosssell-item">
          <div class="pdp__crosssell-form">
            ${imageHtml}
            ${infoHtml}
            <input type="hidden" value="${variant.id}" data-crosssell-variant-id>
            <button type="button" class="pdp__crosssell-add" data-crosssell-add aria-label="Añadir">+</button>
          </div>
        </div>`;
    }
    return `
      <div class="pdp__crosssell-item">
        ${imageHtml}
        ${infoHtml}
        <a href="${product.url}" class="pdp__crosssell-add" aria-label="Ver">+</a>
      </div>`;
  };

  const fetchRecommendations = async (productId, limit, intent) => {
    const url = `/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`;
    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) return [];
      const data = await response.json();
      return data.products || [];
    } catch (error) {
      return [];
    }
  };

  const init = async () => {
    const wrappers = document.querySelectorAll('[data-pdp-crosssell]');
    for (const wrap of wrappers) {
      const list = wrap.querySelector('[data-pdp-crosssell-list]');
      if (!list) continue;
      if (list.querySelector('.pdp__crosssell-item')) {
        wrap.hidden = false;
        continue;
      }

      const productId = wrap.dataset.productId;
      const limit = parseInt(wrap.dataset.limit || '4', 10);
      if (!productId) continue;

      let products = await fetchRecommendations(productId, limit, 'complementary');
      if (products.length === 0) {
        products = await fetchRecommendations(productId, limit, 'related');
      }
      if (products.length === 0) continue;

      list.innerHTML = products.map(renderItem).join('');
      wrap.hidden = false;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
